module.exports = __webpack_public_path__ + "static/media/paper.eb0d1c96.png";